/**
 * 작성자 : 박승호
 * 일자 : 2025.04.25
 * 기능 : 컨펌 확인 모달창
 */
import { IModal } from 'customTypes';
import { BtnGhost, BtnGreen, BtnBlue } from '../Button';
import { ModalBackground, Modal } from '../../assets/styles/Modal';
import { useTranslation } from 'react-i18next';

const ConfirmModal = ({ openModal, setOpenModal, text, confirmMessage = '네', color = 'blue' }: any) => {
  const { t } = useTranslation();

  // 닫기버튼 클릭
  const onClickClose = () => {
    setOpenModal((prev: IModal) => ({ ...prev, status: false }));
  };

  const onClickConfirm = () => {
    openModal.api();
    setOpenModal((prev: IModal) => ({ ...prev, status: false }));
  };

  return (
    <ModalBackground>
      <Modal>
        <div className='modal confirm'>
          <div className='inputForm-head'>{t(text)}</div>
          <div className='modal-footer flex-end'>
            <BtnGhost onClick={onClickClose}>{t('아니요')}</BtnGhost>
            {color === 'green' && <BtnGreen onClick={onClickConfirm}>{confirmMessage}</BtnGreen>}
            {color === 'blue' && <BtnBlue onClick={onClickConfirm}>{confirmMessage}</BtnBlue>}
          </div>
        </div>
      </Modal>
    </ModalBackground>
  );
};

export default ConfirmModal;
